module.exports = __webpack_public_path__ + "static/flags/ZM-6437b96752fa0076a1e25f605967699f.gif";